export default "assets/4b9566ce202dbbc74d7cb236b2651266.png";